// Staff Dashboard shared constants and utilities

export const ROW_HEIGHT = 56; // Fixed height for staff view

// Desktop layout options (Timeline, Cards, My Shifts)
export const DESKTOP_LAYOUT_OPTIONS = [
  { id: "timeline", label: "Timeline", icon: "AlignJustify", description: "Traditional timeline bars" },
  { id: "cards", label: "Cards", icon: "LayoutGrid", description: "Stacked shift cards" },
  { id: "myshifts", label: "My Shifts", icon: "User", description: "Focus on your schedule" },
];

// Mobile layout options (just All Staff vs My Shifts toggle)
export const MOBILE_LAYOUT_OPTIONS = [
  { id: "cards", label: "All Staff", icon: "Users" },
  { id: "myshifts", label: "My Shifts", icon: "User" },
];

export const STORAGE_KEY = "rotalie_staff_preferences";

// Get event color from colorId
export function getEventColor(colorId) {
  const colors = {
    blue: '#3b82f6',
    green: '#22c55e',
    red: '#ef4444',
    yellow: '#eab308',
    purple: '#a855f7',
    pink: '#ec4899',
    orange: '#f97316',
    teal: '#14b8a6'
  };
  return colors[colorId] || colors.blue;
}

// Add opacity to a hex color
export const colorWithOpacity = (color, opacity) => {
  // Handle hex colors
  if (color.startsWith('#')) {
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }
  return color;
};
